// extracted by mini-css-extract-plugin
module.exports = {"aboutRoot":"about_aboutRoot__3tLy7"};